import { StyledAccordionItemSeparator } from '@/shared/components/Accordion/Accordion.styles';
import { StyledCol, StyledTitle } from '@/shared/styles';
import { useTranslation } from 'react-i18next';
import { StyledAccordionContent } from '../AccessibilityIssues.styles';
import { processDescriptionText } from '../AccessibilityIssues.utils';
import { IssueContentProps } from './FilteredIssues.consts';
import { IssueDetails } from './IssueDetails';

export const IssueContent: React.FC<IssueContentProps> = ({ issue }: IssueContentProps) => {
  const { t } = useTranslation();
  return (
    <StyledCol $gap={32}>
      <StyledAccordionItemSeparator />
      <StyledCol $gap={12}>
        <StyledTitle level={3}>{t('free_tools.accessibility_checker.description')}:</StyledTitle>
        <StyledAccordionContent>{processDescriptionText(issue.description)}</StyledAccordionContent>
      </StyledCol>
      <StyledCol $gap={12}>
        <StyledTitle level={3}>
          {t('free_tools.accessibility_checker.filtered_issues.for_example')}:
        </StyledTitle>
        <StyledCol $gap={32}>
          {issue.details.map((item, i) => (
            <IssueDetails
              key={`item${i}`}
              item={item}
              index={i}
              isLast={!(i < issue.details.length - 1)}
            />
          ))}
        </StyledCol>
      </StyledCol>
    </StyledCol>
  );
};
